import React, { useState, useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Tabs,
  Tab,
  Box
} from '@material-ui/core';
import {
  Chat as ChatIcon,
  Dashboard as DashboardIcon
} from '@material-ui/icons';
import RagChat from './RagChat';
import RagDashboard from './RagDashboard';
import authUtil from "../utils/AuthUtils";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`rag-tabpanel-${index}`}
      aria-labelledby={`rag-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column'
  },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper
  },
  tabPanel: {
    flex: 1,
    overflow: 'hidden'
  }
}));

function RagAssistant() {
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const loggedInClient = authUtil.getClientInfo();
    const adminPrivileges = loggedInClient === 'admin' || loggedInClient === 'datachain';
    setIsAdmin(adminPrivileges);
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Paper className={classes.root}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        className={classes.tabs}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab 
          label="Assistant Status" 
          icon={<ChatIcon />}
          id="rag-tab-0"
          aria-controls="rag-tabpanel-0"
        />
        {isAdmin && (
          <Tab 
            label="System Dashboard" 
            icon={<DashboardIcon />}
            id="rag-tab-1"
            aria-controls="rag-tabpanel-1"
          />
        )}
      </Tabs>
      
      <TabPanel value={tabValue} index={0} className={classes.tabPanel}>
        <RagChat />
      </TabPanel>
      
      {isAdmin && (
        <TabPanel value={tabValue} index={1} className={classes.tabPanel}>
          <RagDashboard />
        </TabPanel>
      )}
    </Paper>
  );
}

export default RagAssistant;